import PhoneUtils from './phoneUtils';
import showNotification from 'commons/helpers/showNotification';
import StorageService from 'services/StorageService';
import { prepareMessageForAllVariables } from './messageHelpers';
import { isAppTypeCourtRental } from 'commons/helpers/appTypeSettings';

function getWhatsAppUrl() {
  const isWhatsAppDesktop = StorageService.getIsWhatsAppDesktop();
  const whatsAppUrl = isWhatsAppDesktop ? 'whatsapp://send' : 'https://web.whatsapp.com/send';
  return whatsAppUrl;
}

const WhatsUtils = {
  sendMessage({
    phone,
    text,
    customerName,
    shouldNotCleanUpNumber,
    serviceName,
    date,
    startTime,
    totalServiceValue,
    professionalName,
  }) {
    if (!phone) {
      showNotification('warning', 'Nenhum telefone informado.');
      return;
    }
    const isCourtRental = isAppTypeCourtRental();

    const selectedMsgString = prepareMessageForAllVariables({
      message: text,
      customerName,
      serviceName,
      date,
      startTime,
      totalServiceValue,
      professionalName,
      isCourtRental,
    });

    const sanitizedPhone = shouldNotCleanUpNumber
      ? PhoneUtils.sanitizePhoneNumberRemovePlus(phone)
      : PhoneUtils.sanitizePhoneNumberWithCountryPrefix(phone);

    window.open(
      `${getWhatsAppUrl()}/?phone=${sanitizedPhone}&text=${encodeURIComponent(selectedMsgString)}`,
      '_blank',
    );
  },

  openWhatsApp(fullPhoneCleanedup) {
    window.open(`${getWhatsAppUrl()}/?phone=${fullPhoneCleanedup}`, '_blank');
  },
};
export default WhatsUtils;
